import { common, crypto, JSONHelper, OutputModel } from '@neo-one/client-common';
import { BinaryReader, utils } from '../utils';
export class Output extends OutputModel {
    constructor() {
        super(...arguments);
        this.equals = utils.equals(Output, this, (other) => common.uInt256Equal(this.asset, other.asset) &&
            this.value.eq(other.value) &&
            common.uInt160Equal(this.address, other.address));
        this.toKeyString = utils.toKeyString(Output, () => `${common.uInt256ToString(this.asset)}:${this.value.toString(10)}:${common.uInt160ToString(this.address)}`);
    }
    static deserializeWireBase({ reader }) {
        const asset = reader.readUInt256();
        const value = reader.readFixed8();
        const address = reader.readUInt160();
        return new this({ asset, value, address });
    }
    static deserializeWire(options) {
        return this.deserializeWireBase({
            context: options.context,
            reader: new BinaryReader(options.buffer),
        });
    }
    clone({ value = this.value }) {
        return new Output({
            asset: this.asset,
            value,
            address: this.address,
        });
    }
    serializeJSON(context, index) {
        return {
            n: index,
            asset: JSONHelper.writeUInt256(this.asset),
            value: JSONHelper.writeFixed8(this.value),
            address: crypto.scriptHashToAddress({
                addressVersion: context.addressVersion,
                scriptHash: this.address,
            }),
        };
    }
}

//# sourceMappingURL=Output.js.map
